import {SidebarRoute} from '../../../domain/sidebar-route';
import {Role} from '../../../enum/role';

export const sidebarRouteRegistry: Record<string, SidebarRoute> = {
  personalDashboard: new SidebarRoute(
    'solar:widget-4-outline',
    'solar:widget-4-bold-duotone',
    'Mijn dashboard',
    '/dashboard',
    'personal',
  ),
  teamDashboard: new SidebarRoute(
    'solar:users-group-rounded-outline',
    'solar:users-group-rounded-bold-duotone',
    'Teamdashboard',
    '/dashboard',
    'team',
  ),
  sectors: new SidebarRoute(
    'solar:palette-outline',
    'solar:palette-bold-duotone',
    'Sectoren',
    '/sectoren',
  ),
  companies: new SidebarRoute(
    'solar:buildings-outline',
    'solar:buildings-bold-duotone',
    'Bedrijven',
    '/sectoren/:id/bedrijven',
  ),
  users: new SidebarRoute(
    'solar:users-group-rounded-outline',
    'solar:users-group-rounded-bold-duotone',
    'Gebruikers beheren',
    '/sectoren/:id/bedrijven/:companyId/gebruikers',
  ),
  assessmentsSector: new SidebarRoute(
    'solar:clipboard-outline',
    'solar:clipboard-bold-duotone',
    'Assessments beheren',
    '/sectoren/:id/assessments',
  ),
  employeeManagement: new SidebarRoute(
    'solar:users-group-rounded-outline',
    'solar:users-group-rounded-bold-duotone',
    'Medewerkers beheren',
    '/sectoren/:id/ontwikkeling',
  ),
  myDevelopment: new SidebarRoute(
    'solar:user-id-outline',
    'solar:user-id-bold-duotone',
    'Mijn ontwikkeling',
    '/sectoren/:id/ontwikkeling/:userId',
  ),
  tasks: new SidebarRoute(
    'solar:list-check-outline',
    'solar:list-check-bold-duotone',
    'Taken',
    '/sectoren/:id/taken',
  ),
  competences: new SidebarRoute(
    'solar:lightbulb-bolt-outline',
    'solar:lightbulb-bolt-bold-duotone',
    'Competenties',
    '/sectoren/:id/competenties',
  ),
  knowledge: new SidebarRoute(
    'ion:library-outline',
    'ion:library',
    'Kennis',
    '/sectoren/:id/kennis',
  ),
  companySpecificFunctions: new SidebarRoute(
    'mage:filter',
    'mage:filter-fill',
    'Bedrijfseigenfuncties beheren',
    '/sectoren/:id/bedrijven/:companyId/functies',
  ),
  appointments: new SidebarRoute(
    'solar:calendar-date-outline',
    'solar:calendar-date-bold-duotone',
    'Mijn afspraken',
    '/sectoren/:id/afspraken',
  ),
  assessmentsGlobal: new SidebarRoute(
    'solar:clipboard-outline',
    'solar:clipboard-bold-duotone',
    'Assessments beheren',
    '/sectoren/assessments',
  ),
  careerPath: new SidebarRoute(
    'solar:signpost-outline',
    'solar:signpost-bold-duotone',
    'Carrièrepad',
    '/sectoren/:id/carrierepaden',
  ),
  matching: new SidebarRoute(
    'solar:user-check-outline',
    'solar:user-check-bold-duotone',
    'Matching',
    '/sectoren/:id/bedrijven/:companyId/matching',
  ),
  organogram: new SidebarRoute(
    'ph:tree-structure',
    'ph:tree-structure-duotone',
    'Organogram',
    '/sectoren/:id/bedrijven/:companyId/organogram',
  ),
};

export const sidebarRouteIdsByRole: Record<Role, string[]> = {
  [Role.SUPERADMIN]: [
    'sectors',
    'companies',
    'tasks',
    'competences',
    'knowledge',
    'careerPath',
    'assessmentsGlobal'
  ],
  [Role.ADMIN]: [
    'users',
    'companySpecificFunctions',
    'assessmentsSector',
    'careerPath',
    'organogram'
  ],
  [Role.POPPMMANAGER]: [
    'assessmentsSector',
    'careerPath',
    'appointments'
  ],
  [Role.MANAGER]: [
    'teamDashboard',
    'assessmentsSector',
    'employeeManagement',
    'careerPath',
    'appointments',
    'matching',
    'organogram'
  ],
  [Role.COACH]: [
    'assessmentsSector',
    'employeeManagement',
    'careerPath',
    'appointments',
    'organogram'
  ],
  [Role.EMPLOYEE]: [
    'personalDashboard',
    'myDevelopment',
    'appointments',
    'careerPath',
    'organogram',
  ],
  [Role.TRAINEE]: [
    'personalDashboard',
    'myDevelopment',
    'appointments',
    'careerPath',
    'organogram',
  ],
};

export const sidebarRolePriority: Role[] = [
  Role.TRAINEE,
  Role.EMPLOYEE,
  Role.COACH,
  Role.MANAGER,
  Role.POPPMMANAGER,
  Role.ADMIN,
  Role.SUPERADMIN,
];

export function getVisibleRoutes(currentRoles: Role[]): Array<SidebarRoute & {id: string}> {
  const routes: Array<SidebarRoute & {id: string}> = [];
  const seen = new Set<string>();
  const orderedRoles = sidebarRolePriority.filter(role => currentRoles.includes(role));

  for (const role of orderedRoles) {
    for (const routeId of sidebarRouteIdsByRole[role] ?? []) {
      const route = sidebarRouteRegistry[routeId];
      if (!route || seen.has(routeId)) continue;

      seen.add(routeId);
      routes.push({...route, id: routeId});
    }
  }

  return routes;
}
